import { post } from "@utils/axios_api";

/** 파일명에 들어가면 안 되는 문자 제거 */
export const sanitizeFilename = (name) =>
  name.replace(/[\\/:*?"<>|]/g, "");

/**
 * 공통 엑셀 다운로드
 * ----------------------------------------------------------
 * @param {Object}  cfg
 * @param {String} cfg.url                   API 엔드포인트
 * @param {Object} [cfg.params]              쿼리스트링 또는 POST body
 * @param {String} cfg.filePrefix            예: "회원 목록"
 * @param {Boolean} [cfg.confirm=true]       confirm 창 띄울지
 * ----------------------------------------------------------
 */
export async function downloadExcel({
  url,
  params = {},
  filePrefix,
  customFilename,
  confirm = true,
  msg = "엑셀 다운을 하시겠습니까?"
}) {
  if (confirm) {
    const ok = window.confirm(msg);
    if (!ok) return;
  }

  try {
    const response = await post(url, params, { responseType: "blob" });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const today = new Date();
    const dateStr = today.toISOString().slice(0, 10).replace(/-/g, "");

    const filename = customFilename
    ? `${sanitizeFilename(customFilename)}.xlsx`
    : `${sanitizeFilename(filePrefix)}_${dateStr}.xlsx`;

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (err) {
    console.error("엑셀 다운로드 오류:", err);
    alert("엑셀 다운로드 중 오류가 발생했습니다.");
  }
}
